/**
 * Idempotency tokens for write endpoints. `crypto.randomUUID` is absent on
 * plain-HTTP origins and older browsers, so a `getRandomValues` fallback keeps
 * the token unguessable rather than falling back to `Math.random`.
 */
export const createUuidV4 = (): string => {
  const cryptoApi = globalThis.crypto as Crypto & {
    randomUUID?: () => string;
  };

  if (typeof cryptoApi?.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");

  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join("-");
};
